export default __webpack_public_path__ + "static/media/intuitive.4018d1c9.svg";